import { createFileRoute } from '@tanstack/react-router'
import { AdminPeople } from '../features/admin'
import { peopleQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/people')({
  ...adminRouteState,
  loader: ({ context }) => context.queryClient.ensureQueryData(peopleQuery()),
  component: AdminPeople,
})
